import { Env, readFromEnv } from '@cinch-nx/environments'

/**
 * @deprecated use `Env.SearchServiceUrl` as the URL for fetchSearchVehicles/useSearchVehicles
 */
export const VEHICLE_SEARCH_URL = `${readFromEnv(
  Env.SearchServiceUrl,
)}/vehicles`
